export default __webpack_public_path__ + "static/media/sidebar@2x.c302b888.png";